// SAF-18351 & SAF-18353 Created a new component for viewing document in application
import React from 'react';
import Button from 'spark-ui/ui-kitchen/ingredients/spices/Button';
import { getArrayBuffer } from 'spark-util/fileUtils';
import DetailsPlate from 'spark-ui/ui-kitchen/plates/DetailsPlate';

const InlineViewer = ({fileDetails, fileName, goBack}) => {
    const { byteArray, processedContentType, success } = fileDetails || {};
    if (success && success === false) {
        return (
            <div>
                <p>Failed to load the document. Please try again.</p>
                <Button
                    secondary
                    onClick = {goBack}>Close</Button>
            </div>
        );
    }

    if (!byteArray || !processedContentType) {
        return (<div>
            <p>Loading document...</p>
            <div>
                <Button secondary onClick = {goBack}>Close</Button>
            </div>
        </div>);
    }

    const myList = ["application/pdf"];
    const isUnsupported = !myList.includes(processedContentType) && byteArray != null;

    if (isUnsupported) {
        return <div>Unsupported document type</div>;
    }

    const blob = new Blob([getArrayBuffer(byteArray)], { type: processedContentType });
    const url = URL.createObjectURL(blob);
    const docURL = url;

    return (
        <div>
            <DetailsPlate.Layout 
                identifier={fileName}
                actions={
                    <Button secondary onClick={goBack}>
                        Close
                    </Button>
                }
            >
            {docURL ?
            <iframe
            src={`${docURL}#toolbar=0`}
            title="Document Viewer"
            style={{ width: '100%', height: 600, border: 'none', marginTop: '20px' }}
            /> : <div>Loading document...</div>}
            </DetailsPlate.Layout>
        </div>
    );
};

export default InlineViewer;